import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/icons/filter-icon.svg'


const _hoisted_1 = {
  id: "search-filters",
  role: "button"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Primary filters", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "filter-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "icon"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "filters-wrapper" }
const _hoisted_6 = { class: "multiselect-tag" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "multiselect-tag-remove-icon" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Advanced filters", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "actions-btn" }, [
  /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Refine")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "filter-header-wrapper",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeStyleFilterSearch()))
    }, _hoisted_4),
    _createElementVNode("form", {
      id: "filter-form",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchHandler && _ctx.searchHandler(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_multiselect, {
          modelValue: _ctx.filters.platform,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.platform) = $event)),
          mode: "single",
          options: _ctx.platforms,
          placeholder: "Platform"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_multiselect, {
          modelValue: _ctx.filters.categories,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.categories) = $event)),
          mode: "tags",
          searchable: true,
          options: _ctx.categories,
          placeholder: "Category"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_multiselect, {
          modelValue: _ctx.filters.gender,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.gender) = $event)),
          mode: "tags",
          options: _ctx.genders,
          placeholder: "Gender"
        }, null, 8, ["modelValue", "options"]),
        (_ctx.formattedAges && _ctx.filters.gender.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.filters.gender && _ctx.formattedAges)
                ? (_openBlock(), _createBlock(_component_multiselect, {
                    key: 0,
                    modelValue: _ctx.filters.age,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.age) = $event)),
                    mode: "tags",
                    options: _ctx.formattedAges.length ? _ctx.formattedAges : [],
                    placeholder: "Age",
                    groups: true
                  }, null, 8, ["modelValue", "options"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_multiselect, {
          modelValue: _ctx.filters.residence,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.residence) = $event)),
          mode: "tags",
          options: _ctx.countries,
          searchable: true,
          placeholder: "Location"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_multiselect, {
          modelValue: _ctx.filters.followersCount,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.followersCount) = $event)),
          mode: "tags",
          options: _ctx.followersCount,
          placeholder: "Followers Count"
        }, {
          tag: _withCtx(({ option, disabled, handleTagRemove }) => [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("p", {
                class: "label-custom",
                innerHTML: option.label
              }, null, 8, _hoisted_7),
              (!disabled)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "multiselect-tag-remove",
                    onClick: ($event: any) => (handleTagRemove(option, $event))
                  }, _hoisted_10, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"]),
        _hoisted_11,
        (_ctx.filters.residence)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filters.residence, (residence) => {
              return (_openBlock(), _createBlock(_component_multiselect, {
                key: residence,
                modelValue: _ctx.filters.city[`${residence}`],
                "onUpdate:modelValue": ($event: any) => ((_ctx.filters.city[`${residence}`]) = $event),
                mode: "tags",
                options: _ctx.cities[`${residence}`],
                searchable: true,
                placeholder: 'Select City from ' + residence
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"]))
            }), 128))
          : _createCommentVNode("", true),
        _createVNode(_component_multiselect, {
          modelValue: _ctx.filters.engagementRate,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.engagementRate) = $event)),
          mode: "tags",
          options: _ctx.engagementRates,
          placeholder: "Engagement Rate"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_multiselect, {
          modelValue: _ctx.filters.personReached,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.personReached) = $event)),
          mode: "tags",
          options: _ctx.personReached,
          placeholder: "Active Community"
        }, null, 8, ["modelValue", "options"])
      ]),
      _hoisted_12
    ], 32),
    _createElementVNode("span", {
      id: "reset-filters",
      class: "reset-btn",
      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
    }, "Reset all filters")
  ]))
}